export const PREVIEW_INTERNAL_PARTS_COUNT = 1
export const PREVIEW_WITH_DYNAMIC_INTERNAL_PARTS_COUNT = 2
